// extracted by mini-css-extract-plugin
module.exports = {"TotalsPanel":"IotHubTotals_TotalsPanel__3wN-1","Title":"IotHubTotals_Title__-gXMH","Value":"IotHubTotals_Value__YCgYQ"};